(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = global || self, factory(global.typescriptMonads = {}));
}(this, (function (exports) { 'use strict';

    var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };
    // tslint:disable:readonly-array
    var monad = function (x) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return {
            of: function (x) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                return monad.apply(void 0, __spreadArrays([x], args));
            },
            flatMap: function (f) { return f.apply(void 0, __spreadArrays([x], args)); }
        };
    };

    var isEmpty = function (value) { return value === null || value === undefined; };
    var isNotEmpty = function (value) { return !isEmpty(value); };
    var isSome = function (value) { return function () { return isNotEmpty(value); }; };
    var isNone = function (value) { return function () { return isEmpty(value); }; };
    var valueOr = function (value) { return function (val) { return isEmpty(value) ? val : value; }; };
    var valueOrUndefined = function (value) { return function () { return isEmpty(value) ? undefined : value; }; };
    var toArray = function (value) { return function () { return isEmpty(value) ? [] : Array.isArray(value) ? value : [value]; }; };
    var valueOrCompute = function (value) { return function (fn) { return isEmpty(value) ? fn() : value; }; };
    var tap = function (value) { return function (obj) { return isEmpty(value) ? obj.none && obj.none() : obj.some && obj.some(value); }; };
    var tapNone = function (value) { return function (fn) { return (isEmpty(value)) && fn(); }; };
    var tapSome = function (value) { return function (fn) { return isNotEmpty(value) && fn(value); }; };
    var match = function (value) { return function (pattern) { return isEmpty(value) ? pattern.none() : pattern.some(value); }; };
    var map = function (value) { return function (fn) { return isEmpty(value) ? maybe() : maybe(fn(value)); }; };
    var flatMap = function (value) { return function (fn) { return isEmpty(value) ? maybe() : fn(value); }; };
    var apply = function (value) { return function (maybeFn) { return maybeFn.flatMap(function (f) { return map(value)(f); }); }; };
    var flatMapAuto = function (value) { return function (fn) { return isEmpty(value) ? maybe() : maybe(fn(value)); }; };
    var valueOrThrow = function (value) { return function (msg) { return isEmpty(value) ? (function () { throw Error(msg); })() : value; }; };
    var filter = function (value) {
        return function (fn) {
            return isEmpty(value)
                ? maybe()
                : fn(value)
                    ? maybe(value)
                    : maybe();
        };
    };
    var maybe = function (value) {
        return {
            of: maybe,
            isSome: isSome(value),
            isNone: isNone(value),
            valueOr: valueOr(value),
            valueOrUndefined: valueOrUndefined(value),
            valueOrCompute: valueOrCompute(value),
            valueOrThrow: valueOrThrow(value),
            toArray: toArray(value),
            tap: tap(value),
            tapNone: tapNone(value),
            tapSome: tapSome(value),
            match: match(value),
            map: map(value),
            flatMap: flatMap(value),
            flatMapAuto: flatMapAuto(value),
            filter: filter(value),
            apply: apply(value)
        };
    };
    var maybeToPromise = function (catchResponse) {
        if (catchResponse === void 0) { catchResponse = 'not found'; }
        return function (maybe) { return maybe.isSome()
            ? Promise.resolve(maybe.valueOrUndefined())
            : Promise.reject(catchResponse); };
    };

    var exists = function (t) { return t !== null && t !== undefined; };
    var bothExist = function (left) { return function (right) { return exists(left) && exists(right); }; };
    var neitherExist = function (left) { return function (right) { return !exists(left) && !exists(right); }; };
    var existFunc = function (side) { return function () { return exists(side); }; };
    var tap$1 = function (left) { return function (right) { return function (pattern) {
        return exists(right)
            ? pattern.right && pattern.right(right)
            : pattern.left && pattern.left(left);
    }; }; };
    var match$1 = function (left) { return function (right) { return function (pattern) { return exists(right)
        ? pattern.right(right)
        : pattern.left(left); }; }; };
    var guardBothExist = function (left) { return function (right) {
        // tslint:disable-next-line:no-if-statement
        if (bothExist(left)(right)) {
            throw new TypeError('Either cannot have both a left and a right');
        }
    }; };
    var guardNeitherExist = function (left) { return function (right) {
        // tslint:disable-next-line:no-if-statement
        if (neitherExist(left)(right)) {
            throw new TypeError('Either requires a left or a right');
        }
    }; };
    var eitherGuards = function (left) { return function (right) {
        guardBothExist(left)(right);
        guardNeitherExist(left)(right);
    }; };
    var either = function (left, right) {
        eitherGuards(left)(right);
        return {
            isLeft: existFunc(left),
            isRight: existFunc(right),
            match: match$1(left)(right),
            tap: tap$1(left)(right),
            map: function (f) { return exists(right)
                ? either(undefined, f(right))
                : either(left); },
            flatMap: function (f) { return exists(right) ?
                f(right) :
                either(left); }
        };
    };

    // tslint:disable:no-this
    var reader = function (fn) {
        return {
            of: function (fn) { return reader(fn); },
            run: function (config) { return fn(config); },
            map: function (fn) {
                var _this = this;
                return reader(function (config) { return fn(_this.run(config)); });
            },
            flatMap: function (fn) {
                var _this = this;
                return reader(function (config) { return fn(_this.run(config)).run(config); });
            }
        };
    };

    var returnTrue = function () { return true; };
    var returnFalse = function () { return false; };
    var returnValue = function (val) { return function () { return val; }; };
    var returnMaybe = function (val) { return function () { return maybe(val); }; };
    var throwReferenceError = function (message) { return function () { throw new ReferenceError(message); }; };
    var ok = function (val) {
        return {
            isOk: returnTrue,
            isFail: returnFalse,
            maybeOk: returnMaybe(val),
            maybeFail: maybe,
            unwrap: returnValue(val),
            unwrapOr: function (_) { return val; },
            unwrapFail: throwReferenceError('Cannot unwrap a success'),
            map: function (fn) { return ok(fn(val)); },
            mapFail: function (_) { return ok(val); },
            flatMap: function (fn) { return fn(val); },
            match: function (fn) { return fn.ok(val); }
        };
    };
    var fail = function (err) {
        return {
            isOk: returnFalse,
            isFail: returnTrue,
            maybeOk: maybe,
            maybeFail: returnMaybe(err),
            unwrap: throwReferenceError('Cannot unwrap a failure'),
            unwrapOr: function (opt) { return opt; },
            unwrapFail: returnValue(err),
            map: function (_) { return fail(err); },
            mapFail: function (fn) { return fail(fn(err)); },
            flatMap: function (_) { return fail(err); },
            match: function (fn) { return fn.fail(err); }
        };
    };
    /**
     * Utility function to quickly create ok/fail pairs.
     */
    var result = function (predicate, okValue, failValue) {
        return predicate()
            ? ok(okValue)
            : fail(failValue);
    };
    /**
    * Utility function to quickly create ok/fail pairs, curried variant.
    */
    var curriedResult = function (predicate) {
        return function (okValue) {
            return function (failValue) {
                return result(predicate, okValue, failValue);
            };
        };
    };

    exports.curriedResult = curriedResult;
    exports.either = either;
    exports.fail = fail;
    exports.maybe = maybe;
    exports.maybeToPromise = maybeToPromise;
    exports.monad = monad;
    exports.ok = ok;
    exports.reader = reader;
    exports.result = result;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
